@if (user(); as user) {
<!-- TODO Make p-button -->
<button aria-label="{{ 'navbar.userProfile' | translate }}" title="{{ 'navbar.userProfile' | translate }}"
    (click)="userMenu.toggle($event)"
    styleClass="h-11 w-11 overflow-hidden rounded-full border border-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500">
    @if(user.photoURL) {
    <img [src]="user.photoURL" alt="User Profile" class="w-11 h-11 rounded-full object-cover" />
    }
    @else {
    <div
        class="hover:cursor-pointer flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-slate-900 via-slate-700 to-slate-800 text-sm font-semibold uppercase text-white">
        {{getInitials(user)}}
    </div>
    }
</button>
<p-menu #userMenu [model]="items()" [popup]="true" class="hidden lg:flex" />
}
@else {
<p-button variant="outlined" [rounded]="true" severity="secondary" icon="pi pi-user"
    aria-label="{{ 'navbar.login' | translate }}" title="{{ 'navbar.login' | translate }}"
    (click)="router.navigate(['/auth/login'])" styleClass="h-11! w-11! dark:border-white dark:text-white">
</p-button>
}